import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import useStyles from './styles';

const HowToFallback = () => {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });

  return (
    <div className={styles.skeletonRoot}>
      <div className={styles.howToContent}>
        <Skeleton className={styles.skeletonTitle} />
        <ul className={styles.sekeletonItemWrapper}>
          <li className={styles.sekeletonListItem}>
            <Skeleton className={styles.skeletonListTitle} />
            <Skeleton className={styles.skeletonListDescription} />
            <Skeleton className={styles.skeletonButton} />
          </li>
        </ul>
      </div>
      <div className={styles.mediaHolder}>
        <Skeleton className={styles.imageSkeleton} />
      </div>
    </div>
  );
};

export default HowToFallback;
